import { Container, Workflow } from '@apiContract';
import { useSettings } from 'src/hooks/useSettings';
import { useGetContainerTypesQuery } from 'src/redux/api/container';
import { SortingOrder } from 'src/types/contractHelpers';
import { getContainerDefaultValues } from 'src/utils/container';

export const useDefaultContainerValue = (workflow: Workflow, container?: Container) => {
  const { data: containerTypes = [] } = useGetContainerTypesQuery();
  const sortOrder = (useSettings(['ReceiveSortOrder']) as { ReceiveSortOrder: SortingOrder }).ReceiveSortOrder;

  if (container && workflow === container.containerType.workflow) {

    return {
      containerTypeId: container.containerType.id,
      createdDate: container.createdDate,
      containerNumber: container.containerNumber,
      sortOrder: container.sortOrder,
    }

  }

  return getContainerDefaultValues(containerTypes, sortOrder, workflow);
};
